import useSwr from 'swr';
import ActivitiesHostPaymentQualification, {
  ActivitiesHostPaymentQualificationRes,
} from '@quickService/ActivitiesHostPaymentQualification';

/**
 * 获取主办方付费资质
 * @param hostId 主办方id
 * @returns 主办方付费资质
 */
const usePaymentQualification = (hostId: string) => {
  const { data, mutate, isLoading } = useSwr(
    {
      url: '/v2/activities/host/payment-qualification',
      params: { host_id: hostId },
    },
    ({ params }) => {
      if (!params?.host_id) return Promise.reject('hostId不能为空');
      return ActivitiesHostPaymentQualification(params).then(
        (res: ActivitiesHostPaymentQualificationRes) => {
          if (res.code === 0) {
            return res.data;
          }
          return Promise.reject(res?.msg || '');
        },
      );
    },
    {
      revalidateOnFocus: false,
      errorRetryCount: 1,
    },
  );
  return {
    hasPaymentQualification: data?.has_payment_qualification,
    hasEventPayment: data?.has_event_payment,
    mutate,
    isLoading,
  };
};

export default usePaymentQualification;
